var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(-2720 -22875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M5.864,8.9a.6.6,0,0,1,0-.849L8.776,5.137H.6a.6.6,0,1,1,0-1.2H8.777L5.864,1.024A.6.6,0,0,1,6.712.176L10.65,4.113a.6.6,0,0,1,.148.245v0l0,.011v0l0,.008,0,.007V4.4l0,.009v0l0,.011v0l0,.011v0l0,.012v0l0,.012v.058s0,.009,0,.013v0h0c0,.005,0,.01,0,.015v0s0,.007,0,.011v.065l0,.009v0l0,.01v0l0,.012h0a.6.6,0,0,1-.16.289L6.712,8.9a.6.6,0,0,1-.849,0Z",
    transform: "translate(2730 22886)",
    fill: "#b386c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    d: "M14.5-.5h2A14.446,14.446,0,0,1,27.107,4.186,16.448,16.448,0,0,1,31.5,15.5a16.448,16.448,0,0,1-4.393,11.314A14.446,14.446,0,0,1,16.5,31.5h-2A14.446,14.446,0,0,1,3.893,26.814,16.448,16.448,0,0,1-.5,15.5,16.448,16.448,0,0,1,3.893,4.186,14.446,14.446,0,0,1,14.5-.5Zm2,30.933a13.483,13.483,0,0,0,9.9-4.374A15.352,15.352,0,0,0,30.5,15.5,15.352,15.352,0,0,0,26.4,4.941,13.483,13.483,0,0,0,16.5.567h-2A13.483,13.483,0,0,0,4.6,4.941,15.352,15.352,0,0,0,.5,15.5,15.352,15.352,0,0,0,4.6,26.059a13.483,13.483,0,0,0,9.9,4.374Z",
    transform: "translate(2720.5 22875.5)",
    fill: "#b386c5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGo);
export default __webpack_public_path__ + "static/media/icon-go.a37206748ad8f7cfae7d7d0189ab7b39.svg";
export { ForwardRef as ReactComponent };